var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.59 3.015a.6.6 0 0 0-.348.19.6.6 0 0 0-.133.652c.043.113.185.255 3.838 3.8a657 657 0 0 1 3.794 3.696c0 .008-3.887.018-8.638.02l-8.638.006-.09.046c-.28.145-.42.414-.362.693.043.205.16.354.363.459l.089.046 8.638.005c4.75.003 8.638.012 8.638.02s-1.708 1.672-3.794 3.697c-3.693 3.585-3.795 3.685-3.84 3.804-.14.37.097.771.5.842a.75.75 0 0 0 .398-.048c.097-.043 8.836-8.502 8.912-8.626a.67.67 0 0 0 .017-.612c-.037-.072-8.726-8.513-8.85-8.596a.63.63 0 0 0-.493-.094",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;